import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { fmtInt } from '../../lib/format'
import { pct } from '../../lib/chartGeometry'

export interface BarRow {
  label: string
  value: number
  display?: string
  href?: string
}

export function BarList({ rows, max }: { rows: BarRow[]; max?: number }) {
  const top = max ?? Math.max(0, ...rows.map((r) => r.value))
  return (
    <div className="flex flex-col gap-3">
      {rows.map((r) => {
        const body: ReactNode = (
          <>
            <div className="flex items-baseline justify-between gap-3 font-mono text-[12px]">
              <span className="text-paper-dim truncate">{r.label}</span>
              <span className="text-paper" style={{ fontVariantNumeric: 'tabular-nums' }}>
                {r.display ?? fmtInt(r.value)}
              </span>
            </div>
            <div className="w-full bg-ink-600 mt-1" style={{ height: 6 }} aria-hidden="true">
              <div style={{ height: '100%', width: `${Math.min(100, pct(r.value, top))}%`, background: '#c77d1f' }} />
            </div>
          </>
        )
        return r.href ? (
          <Link key={r.label} to={r.href} className="block hover:bg-ink-600">
            {body}
          </Link>
        ) : (
          <div key={r.label}>{body}</div>
        )
      })}
    </div>
  )
}
